(function(){
    'use strict';

    document.querySelectorAll('.lhs-wrapper').forEach( (e)=> {e.innerHTML.trim() === '' ? e.style.display='none' : ''});

    document.querySelectorAll('a').forEach( (a)=> { (a.innerText.match(/\[[0-9]*\]/)) ? (a.style.cssText="vertical-align:super;font-size:smaller") : ""; });

}());
